<template>
  <div id="app">
    <router-view/>
    <component :is="dialogInfo.innerComponent"></component>
  </div>
</template>

<script>
import { getQueryString } from './router/Interceptor';

export default _extend({
  name: 'App',
  computed: {
    dialogInfo () {
      return this.$store.state.dialog.dialogInfo;
    }
  },
  beforeCreate() {
    _timeEnd('page load');

    const masterSn = getQueryString('masterSn');
    this.$fa.setEnv({
      $tid: masterSn
    });
  },
});
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@font-face {
  font-family: 'iconfont';  /* project id 406505 */
  src: url('https://at.alicdn.com/t/font_406505_n68v6y75blqh0k9.eot');
  src: url('https://at.alicdn.com/t/font_406505_n68v6y75blqh0k9.eot?#iefix') format('embedded-opentype'),
  url('https://at.alicdn.com/t/font_406505_n68v6y75blqh0k9.woff') format('woff'),
  url('https://at.alicdn.com/t/font_406505_n68v6y75blqh0k9.ttf') format('truetype'),
  url('https://at.alicdn.com/t/font_406505_n68v6y75blqh0k9.svg#iconfont') format('svg');
}
.icon {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  color: #313338;
}
.icon-global {
  display: inline-block;
  height: 16px;
  width: 16px;
  &:after {
    color: black;
    content: '\e647';
  }
}
.icon-down {
  &:after {
    color: black;
    content: '\e676'
  }
}

input, textarea, div {
  caret-color: #4981F2;
  -webkit-caret-color: #4981F2;
}
</style>



// WEBPACK FOOTER //
// src/App.vue